import type { RequestOptions } from '@mts-fe/types';
import type { AxiosRequestConfig } from 'axios';
import { createAsyncComponent, withInstall } from '@mts-fe/utils';
import type { MButtonProps } from '../Button';
import _AsyncExport from './src/AsyncExport.vue';
import _AsyncExportModal from './src/AsyncExportModal.vue';
import _SyncExportBtn from './src/SyncExportBtn.vue';

/** @deprecated */
export const AsyncExport = withInstall(_AsyncExport);
/** @deprecated */
export const AsyncExportModal = createAsyncComponent(() => import('./src/AsyncExportModal.vue'));
/** @deprecated */
export const SyncExportBtn = withInstall(_SyncExportBtn);

export type MExportProps = {
  /** 导出接口路径 /微服务/xxx */
  path: string;
  /** 导出接口参数 */
  params?: object | (() => object);
  axiosConfig?: AxiosRequestConfig;
  axiosOptions?: RequestOptions;
} & MButtonProps;
